import { ModuleLicenseInfo, ModuleOrganization } from '@/store/module-const';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters(ModuleLicenseInfo, ['Config']),
        ...mapGetters(ModuleOrganization, ['getOrganizationWorking']),
        isCheckThirdParty() {
            const me = this;
            return (
                me.getOrganizationWorking && me.getOrganizationWorking.IsCheckThirdParty
            );
        },
    },
    methods: {
        /**
         * Kiểm tra xem có phải là hóa đơn theo Nghị định 70 hay không
         * @param {Object} currentItem - Hóa đơn hiện tại
         * @returns {Boolean} True nếu là hóa đơn Nghị định 70
         */
        checkInvoiceDecree70(currentItem) {
            const me = this;
            return (
                currentItem &&
                me.Config &&
                me.Config.VersionXMLDecree70s &&
                me.Config.VersionXMLDecree70s.includes(currentItem.VersionXML) &&
                !me.checkReceiptDecree70(currentItem) &&
                currentItem.IsSupportInvoiceDecree70
            );
        },

        /**
         * Kiểm tra xem có phải là hóa đơn theo Nghị định 254 hay không
         * @param {Object} currentItem - Hóa đơn hiện tại
         * @returns {Boolean} True nếu là hóa đơn Nghị định 254
         */
        checkInvoiceDecree254(currentItem) {
            const me = this;
            if (!currentItem) return false;
            //Ưu tiên field InvoiceDecreeType BE ghi khi lưu hóa đơn
            if (currentItem.InvoiceDecreeType) {
                return currentItem.InvoiceDecreeType === me.$ms.enum.InvoiceDecreeType.ND254;
            }
            //Fallback: HĐ cũ lưu trước khi có field InvoiceDecreeType => check theo phiên bản XML
            return (
                me.Config &&
                me.Config.VersionXMLDecree254s &&
                me.Config.VersionXMLDecree254s.includes(currentItem.VersionXML) &&
                currentItem.IsInvoice123
            );
        },

        checkInvoiceSpecificProduct(currentItem) {
            const me = this;
            return me.checkInvoiceDecree70(currentItem) || me.checkInvoiceDecree254(currentItem);
        },

        /**
         * Vé GTGT nghị định 70
         * @param {*} currentItem 
         * @returns 
         */
        checkValueAddedTicketDeree70(currentItem) {
            const me = this;
            return (
                currentItem &&
                me.Config &&
                me.Config.VersionXMLDecree70s &&
                me.Config.VersionXMLDecree70s.includes(currentItem.VersionXML) &&
                !me.checkReceiptDecree70(currentItem) &&
                currentItem.IsValueAddedTicket
            );
        },

        /**
         * Kiểm tra xem có phải là biên lai Nghị định 70 hay không
         * @param {Object} currentItem - Hóa đơn hiện tại
         * @returns {Boolean} True nếu là biên lai Nghị định 70
         */
        checkReceiptDecree70(currentItem) {
            const me = this;
            return currentItem && currentItem.IsReceiptDecree70;
        },

        /**
         * Kiểm tra xem có phải là hóa đơn Thương mại Nghị định 70 hay không
         * @param {Object} currentItem - Hóa đơn hiện tại
         * @returns {Boolean} True nếu là hóa đơn Thương mại Nghị định 70
         */
        checkInvoiceCommercialInvoiceDecree70(currentItem) {
            const me = this;
            return (
                currentItem.IsCommercialInvoice &&
                me.checkInvoiceDecree70(currentItem)
            );
        },

        /**
         * Kiểm tra xem có phải là template InvoiceSales70 hay không
         * Bao gồm: HĐ Bán hàng ND70 hoặc HĐ Thương mại ND70
         * @param {Object} currentItem - Hóa đơn hiện tại
         * @returns {Boolean} True nếu là template InvoiceSales70
         */
        isCheckTemplateInvoiceSales70(currentItem) {
            const me = this;
            return (me.checkInvoiceDecree70(currentItem) &&
                currentItem.InvCustomTemplate === me.$ms.enum.InvoiceCustomTemplate.InvoiceSales) ||
                me.checkInvoiceCommercialInvoiceDecree70(currentItem);
        },


        /**
         * Các TH vé kiểm tra nâng cao
         * @param {*} currentItem 
         * @returns 
         */
        isTicketAdvance(currentItem) {
            if (!currentItem) return false;
            return currentItem.IsValueAddedTicketRegisterCash || currentItem.IsValueAddedTicket
                || currentItem.IsSalesTicketWithoutCode || currentItem.IsSalesTicketWithCode;
        },

        /**
         * Các TH vé NĐ70
         * @param {*} currentItem 
         * @returns 
         */
        isTicketAdvance70(currentItem) {
            const me = this;
            if (!currentItem) return false;
            return me.checkInvoiceDecree70(currentItem) && me.isTicketAdvance(currentItem);
        },

        //HĐ GTGT (có mã, k mã)
        isValueAddedInvoice(currentItem) {
            const me = this;
            if (!currentItem) return false;
            return currentItem.IsValueAddedInvoice;
        },

        // HĐ Bán hàng(có mã, k mã)
        isValueInvoiceSales(currentItem) {
            const me = this;
            if (!currentItem) return false;
            return currentItem.IsValueInvoiceSales;
        },

        //HĐ GTGT/bán hàng MTT
        isInvoiceRegister(currentItem) {
            const me = this;
            if (!currentItem) return false;
            return currentItem.IsValueAddedRegisterCash || currentItem.IsValueAddedRegisterSales;
        },
    }
};